/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react"
import axios from "axios"
import { graphql, useStaticQuery, navigate } from "gatsby"
import Layout from "@components/Layout/Layout"
import Filter from "@components/SearchResults/FilterBox/FilterBox"
import PropertyInfo from "@components/SearchResults/PropertyInfo/PropertyInfo"
import SalesCard from "@components/SearchResults/SalesCard/SalesCard"
import ArrowLeft from "@components/icons/ChevronLeft"
import { propertyIntro, getSeoDesc } from "@common/utils/property_utils"
import SeoResult from "@common/seoResult"
import { defaultArea, apiAddressyKey } from "@common/constant"
import LeafletMapReults from "@components/maps/leaflet/results"

import "@styles/search-results.scss"

// const LeafletMapReults = React.lazy(() =>
//   import("../components/maps/leaflet/results"),
// )

const {
  parseResultsUrl,
  generateFiltersfromPageData,
  getAlgoliaResults,
} = require("../gatsby-library-common/PropertySearchNew")

const SearchResults = (props) => {
  // const [mapView, setMapView] = useState(false)

  // const [latLang, setLatLang] = useState("")

  const data = useStaticQuery(graphql`
    query {
      strapiPropertySearch {
        ...PropertySearchFragment
      }

      resiSales: allProperties(
        limit: 6
        sort: { fields: id, order: DESC }
        filter: {
          publish: { eq: true }
          department: { eq: "residential" }
          search_type: { eq: "sales" }
          status: { eq: "For Sale" }
        }
      ) {
        nodes {
          ...propertyFragment
        }
      }

      resiLettings: allProperties(
        limit: 6
        sort: { fields: id, order: DESC }
        filter: {
          publish: { eq: true }
          department: { eq: "residential" }
          search_type: { eq: "lettings" }
          status: { eq: "To Let" }
        }
      ) {
        nodes {
          ...propertyFragment
        }
      }

      commSales: allProperties(
        limit: 6
        sort: { fields: id, order: DESC }
        filter: {
          publish: { eq: true }
          department: { eq: "commercial" }
          search_type: { eq: "sales" }
          status: { eq: "For Sale" }
        }
      ) {
        nodes {
          ...propertyFragment
        }
      }

      commLettings: allProperties(
        limit: 6
        sort: { fields: id, order: DESC }
        filter: {
          publish: { eq: true }
          department: { eq: "commercial" }
          search_type: { eq: "lettings" }
          status: { eq: "To Let" }
        }
      ) {
        nodes {
          ...propertyFragment
        }
      }
    }
  `)

  const { location } = props
  const { pathname } = location
  const pageUrlData = parseResultsUrl(location)
  const myalgoliafilters = generateFiltersfromPageData(pageUrlData)

  const propertySearch = data?.strapiPropertySearch

  let noProperty = data?.resiSales
  if (
    pageUrlData.departmentVal === "residential" &&
    pageUrlData.searchtypeVal === "lettings"
  ) {
    noProperty = data?.resiLettings
  } else if (
    pageUrlData.departmentVal === "commercial" &&
    pageUrlData.searchtypeVal === "sales"
  ) {
    noProperty = data?.commSales
  } else if (
    pageUrlData.departmentVal === "commercial" &&
    pageUrlData.searchtypeVal === "lettings"
  ) {
    noProperty = data?.commLettings
  }

  // console.log("pageUrlData", pageUrlData)

  const local_storage_data =
    typeof window !== "undefined" && localStorage.getItem("algolia_data")
      ? JSON.parse(localStorage.getItem("algolia_data"))
      : []

  // console.log("local_storage_data", local_storage_data)

  const [searchState, setSearchState] = useState({})
  const [algoliaData, setAlgoliaData] = useState({})
  const [latLang, setLatLang] = useState("all")
  const [loading, setLoading] = useState(true)
  const [showMapView, setShowMapView] = useState(false)
  const [areaList, setAreaList] = useState([])
  // eslint-disable-next-line react/hook-use-state
  const [local_cache, setLocalCache] = useState(local_storage_data)

  // you can make default search page results filters here

  // eslint-disable-next-line consistent-return
  // const getitems = async (url) => {
  //   try {
  //     const result = await axios.get(url, {})
  //     return result
  //   } catch (error) {
  //     console.error("address api error", error)
  //   }
  // }

  /* ========= Local Cache =========== */
  const filterLocalCache = (path_name) => {
    const get_local_cache = local_cache
    let filter_local_cache = []
    // filter_local_cache = get_local_cache.length > 0 && get_local_cache.filter(key => key[path_name]);

    if (get_local_cache?.length > 0) {
      const remove_local_cache = get_local_cache?.filter(
        (key) => Object.values(key)[0]?.expTime > new Date().getTime(),
      )

      setLocalCache(remove_local_cache)

      filter_local_cache =
        remove_local_cache?.length > 0 &&
        remove_local_cache?.filter((key) => key[path_name])
    }

    // console.log("algoliadata 2", path_name, this.state.local_cache, filter_local_cache)

    return filter_local_cache
  }

  useEffect(() => {
    // const areaRes = []

    setSearchState(pageUrlData)

    if (pageUrlData.areaVal !== defaultArea.toLowerCase()) {
      fetch("/property-search-areas.json").then((res) =>
        res.json().then((areas) => {
          const selectArea = areas.filter(
            (item) => item.area_name.toLowerCase() === pageUrlData.areaVal,
          )
          if (selectArea?.length > 0) {
            setLatLang(`${selectArea[0].latitude},${selectArea[0].longitude}`)
          } else {
            setLatLang("all")
          }
        }),
      )

      // if (typeof window !== "undefined") {
      //   const geo = new window.google.maps.Geocoder()
      //   geo.geocode(
      //     { address: `${pageUrlData.areaVal}, UK` },
      //     function (results, status) {
      //       if (status === window.google.maps.GeocoderStatus.OK) {
      //         const myLatLng = results[0].geometry.location
      //         // Add some code to work with myLatLng
      //         // console.log("myLatLng", myLatLng, results)
      //         // console.log(
      //         //   `myLatLng Lat and Long: ${myLatLng}, ${myLatLng.lat()}, ${myLatLng.lng()}`,
      //         // )
      //         if (myLatLng.lat()) {
      //           setLatLang(`${myLatLng.lat()},${myLatLng.lng()}`)
      //         }
      //       } else {
      //         // console.log("myLatLng status", status, results)
      //         setLatLang("all")
      //       }
      //     },
      //   )
      // }
    } else {
      setLatLang("all")
    }
  }, [location])

  useEffect(() => {
    const pageLimit = 15
    // console.log("latLang ==>", latLang)

    /* ========= Local Cache =========== */
    const path_name = typeof window !== "undefined" ? window.location.href : ""
    const expTime = new Date().setMinutes(new Date().getMinutes() + 5)

    let local_cache_path_name = path_name
    let local_cache_filter_data = myalgoliafilters
    if (showMapView) {
      local_cache_filter_data += " AND (map_view:true)"
      local_cache_path_name += "map-view/"
    }

    const filter_local_cache = filterLocalCache(local_cache_path_name)

    // console.log(
    //   "myalgoliafilters",
    //   local_cache_filter_data,
    //   " ==== ",
    //   filter_local_cache?.length > 0 &&
    //     filter_local_cache[0][local_cache_path_name].filter_data,
    // )

    if (
      filter_local_cache?.length > 0 &&
      local_cache_filter_data ===
        filter_local_cache[0][local_cache_path_name].filter_data
    ) {
      // console.log("algoliadata 1", filter_local_cache)
      const get_data = filter_local_cache[0]
      const get_data_pathname = get_data[local_cache_path_name]
      // console.log("get_data ==>", get_data_pathname);

      if (get_data_pathname?.total > 0) {
        setAlgoliaData(get_data_pathname)
      } else {
        setAlgoliaData([])
      }
    } else if (searchState?.departmentVal) {
      getAlgoliaResults(
        myalgoliafilters,
        pageUrlData,
        pageLimit,
        latLang,
        showMapView,
      ).then(({ nbHits, page, hitsPerPage, nbPages, hits }) => {
        /* ========= Local Cache expTime =========== */
        const myArray = {
          total: nbHits,
          currentPageNumber: page,
          hitsPerPage,
          numberOfPages: nbPages,
          hits,
          expTime,
          filter_data: local_cache_filter_data,
        }

        setLoading(false)
        if (nbHits > 0) {
          setAlgoliaData(myArray)
        } else {
          setAlgoliaData([])
        }

        if (!showMapView) {
          /* ========= Local Cache =========== */
          setLocalCache([...local_cache, { [local_cache_path_name]: myArray }])
        }
      })
    }

    // console.log("local_cache ==>", local_cache, path_name)
  }, [latLang, searchState, showMapView])

  useEffect(() => {
    localStorage.setItem("algolia_data", JSON.stringify(local_cache))
  }, [local_cache])

  let intro = ""
  let metaIntro = ""
  let seoDesc = ""

  if (searchState?.departmentVal) {
    intro = propertyIntro(pageUrlData, propertySearch?.property_type)
    metaIntro = propertyIntro(
      { ...searchState, introCopy: true },
      propertySearch?.property_type,
    )
    seoDesc = getSeoDesc(pageUrlData, propertySearch?.property_type)
  }

  // eslint-disable-next-line no-unused-vars
  const changeMapView = () => {
    const changePath = pathname.replace("map-view/", "")
    navigate(changePath)
  }

  // console.log("location==>", pageUrlData, searchState)

  // const ldJson = ""

  const itemListElement = []
  if (algoliaData?.total > 0 && algoliaData?.hits) {
    // eslint-disable-next-line array-callback-return
    algoliaData?.hits.map((val, key) => {
      let details_path = "/property-for-sale"
      if (val.department === "residential" && val.search_type === "lettings") {
        details_path = "/property-to-rent"
      } else if (
        val.department === "commercial" &&
        val.search_type === "sales"
      ) {
        details_path = "/commercial-property-for-sale"
      } else if (
        val.department === "commercial" &&
        val.search_type === "lettings"
      ) {
        details_path = "/commercial-property-to-rent"
      }
      let propid = ""
      if (val?.strapi_id) propid = val.strapi_id
      else if (val?.objectID) propid = val.objectID
      itemListElement.push({
        "@type": "ListItem",
        position: key + 1,
        url: `${process.env.GATSBY_SITE_URL + details_path}/${
          val.slug
        }/${propid}/`,
        name: val.slug.replace(/-/g, " "),
      })
    })
  }

  const ldJson = algoliaData?.hits
    ? {
        "@context": "https://schema.org",
        "@type": "SearchResultsPage",
        publisher: {
          "@type": "Corporation",
          name: `${process.env.GATSBY_SITE_NAME} in ${process.env.GATSBY_DEFAULT_AREA}`,
          logo: {
            "@type": "ImageObject",
            url: `${process.env.GATSBY_SITE_URL}/images/logo.png`,
            width: 250,
            height: 100,
          },
        },
        mainEntity: {
          "@type": "ItemList",
          numberOfItems: algoliaData?.total,
          name: metaIntro,
          description: seoDesc,
          itemListElement,
        },
      }
    : ""

  // console.log("algoliaData ==>", algoliaData)
  let popularSearchObject = {
    department: searchState?.departmentVal,
    searchType: searchState?.searchtypeVal,
    action: searchState?.pagepath,
    area: searchState?.areaVal,
    postcode: searchState,
    bedrooms: searchState?.bedVal,
    propertyType: searchState?.buildingval,
    minprice: searchState?.minpriceVal,
    maxprice: searchState?.maxpriceVal,
  }
 
  return (
    <Layout
      pageData={{
        custom_css_classname: "search-results-page",
        layout: "search-results",
      }}
      popularSearch={searchState?.departmentVal}
      popularSearchObject={popularSearchObject}
      removeFixedHeader={true}
    >
      {/* <SEO title={metaIntro} description={`${seoDesc}`} /> */}

      {/* <SeoResult
        title={metaIntro}
        description={`${seoDesc}`}
        image_url="https://ggfx-webbers.s3.eu-west-2.amazonaws.com/x.prod/property/BRA220108/images/web/live/pictures/BRA/22/640x/BRA220108_31.webp"
        schema={ldJson}
    /> */}

      {searchState?.departmentVal && (
        <Filter
          propertySearch={propertySearch}
          searchState={searchState}
          pathName={pathname}
          // algoliaData={algoliaData}
        />
      )}

      {searchState?.departmentVal &&
        (showMapView ? (
          <div className="map-results">
            <button
              className="back-map-btn d-flex align-items-center"
              onClick={() => setShowMapView(false)}
            >
              <ArrowLeft /> Exit Map
            </button>
            <LeafletMapReults
              departmentVal={searchState?.departmentVal}
              hits={algoliaData?.hits}
              propertyTypeVal={searchState?.propertyTypeVal}
            />
          </div>
        ) : (
          <div className="search-result-wrapper">
            {searchState?.departmentVal && (
              <>
                <PropertyInfo
                  introText={intro}
                  searchState={searchState}
                  algoliaData={algoliaData}
                  sortBy={propertySearch?.sort_by}
                  propertyTypeList={propertySearch?.property_type}
                  pathName={pathname}
                  metaIntro={metaIntro}
                  loading={loading}
                  setShowMapView={setShowMapView}
                />
                <SalesCard
                  searchState={searchState}
                  algoliaData={algoliaData}
                  pathName={pathname}
                  marketingBanner={propertySearch?.marketing_banners}
                  noProperty={noProperty}
                />
              </>
            )}
          </div>
        ))}
    </Layout>
  )
}

export default SearchResults
